"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NegativeBalancesHeader = void 0;
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/eob/store");
const store_2 = require("client/modules/reporting/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const util_1 = require("shared/util");
require("./negative-balances-header.less");
let NegativeBalancesHeader = class NegativeBalancesHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.siteId = 0;
        this.payerName = "All Payers";
        this.headerToggle = () => {
            store_2.reportsStore.editModal = !store_2.reportsStore.editModal;
        };
        this.handleLoader = () => {
            store_2.reportsStore.showLoader = !store_2.reportsStore.showLoader;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleChangePayer = (value) => {
            this.payerName = value;
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            await store_2.reportsStore.loadNegativeBalances(this.siteId, this.payerName, true);
        };
        this.handleCancel = () => {
            store_2.reportsStore.editModal = !store_2.reportsStore.editModal;
        };
    }
    componentWillMount() {
        if (store_4.usersStore.user.value &&
            store_4.usersStore.user.value.siteUser &&
            store_4.usersStore.user.value.siteId) {
            this.siteId = store_4.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            store_3.sitesListStore.loadSitesNoRelation();
        }
        store_1.eobStore.loadPayers();
    }
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_4.usersStore.user.value.user;
        if (isImbUser) {
            if (store_3.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_3.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_4.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    get availablePayers() {
        const options = [];
        if (store_1.eobStore.payers) {
            options.push({ id: 0, label: "All Payers", value: "All Payers" });
            store_1.eobStore.payers.forEach((payer, i) => {
                const indexStandardizer = 1;
                options.push({
                    id: i + indexStandardizer,
                    label: payer.shortName,
                    value: payer.shortName.toString()
                });
            });
        }
        return options;
    }
    render() {
        const { label = "Search", title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options")),
            store_2.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "40%", top: "25%", width: "25%", overflowY: true, buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "" },
                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, onInputChange: e => {
                                    util_1.pharmacyDropDownHandler({
                                        id: Number(this.siteId),
                                        search: e
                                    });
                                }, value: String(this.siteId) || "", width: "100%" }),
                            React.createElement("br", null),
                            React.createElement(select_1.MaterialSelect, { options: this.availablePayers, required: true, searchable: true, label: "Payer", onSelect: this.handleChangePayer, value: String(this.payerName) || "", width: "100%" })))))) : null,
            store_2.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.observable
], NegativeBalancesHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], NegativeBalancesHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], NegativeBalancesHeader.prototype, "payerName", void 0);
__decorate([
    mobx_1.computed
], NegativeBalancesHeader.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], NegativeBalancesHeader.prototype, "availablePayers", null);
NegativeBalancesHeader = __decorate([
    mobx_react_1.observer
], NegativeBalancesHeader);
exports.NegativeBalancesHeader = NegativeBalancesHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/negative-balances/components/negative-balances-header/negative-balances-header.tsx
// module id = 3921
// module chunks = 0